// frontend/src/components/SuggestionModal.js
import React, { useEffect } from 'react';
import { useForm, ValidationError } from '@formspree/react';

function SuggestionModal({ onClose }) {
  const [state, handleSubmit] = useForm(process.env.REACT_APP_FORMSPREE_FORM_ID);

  useEffect(() => {
    if (!state.succeeded) return;
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [state.succeeded, onClose]);

  return (
    <div
      className="suggestion-overlay"
      data-testid="suggestion-backdrop"
      onClick={onClose}
    >
      <div className="suggestion-panel" onClick={(e) => e.stopPropagation()}>
        <button className="suggestion-close" onClick={onClose} aria-label="Close">✕</button>
        <h3>Suggest an Improvement</h3>
        <p className="suggestion-subtitle">What could be better on AeroSuggest?</p>

        {state.succeeded ? (
          <div className="suggestion-success">
            <span>💡</span>
            <p>Thanks for the feedback!</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <textarea
                name="message"
                rows={5}
                placeholder="What could be better?"
                required
              />
              <ValidationError field="message" prefix="Message" errors={state.errors} />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your email (optional)"
              />
              <ValidationError field="email" prefix="Email" errors={state.errors} />
            </div>
            <button type="submit" className="btn btn-primary" disabled={state.submitting}>
              {state.submitting ? 'Sending…' : 'Send'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default SuggestionModal;
